import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tenant-groups-filter',
  templateUrl: './tenant-groups-filter.component.html',
  styleUrl: './tenant-groups-filter.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, MatButtonModule],
})
export class TenantGroupsFilterComponent {
  public readonly createTenantGroup = output<void>();
}
